module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/maps-sidebar/components/place-filter/place-filter.component.less
// module id = ./src/app/modules/maps-sidebar/components/place-filter/place-filter.component.less
// module chunks = main